import { NodeModel } from "../_model/NodeModel";
import { DecorationConcentratorYeast } from "./decorationConcentratorYeast";
import { Types } from "../../utils/nodeTypes";
import Properties from "../_model/ModelEngineeringProperties";

class ConcentratorYeast extends NodeModel {
    constructor() {
        super("ConcentratorYeast");

        this.type = new Types().ConcentratorYeast;

        this.x = 0;
        this.y = 0;
        this.xImg = () => this.x + 2;
        this.yImg = () => this.y + 2;
        this.height = 100;
        this.width = 80;
        this.tx = 0;
        this.Xw = 0;
        this.operationSelected = '';
        this.srcImg = require("@/assets/Fluxogramas/evaporador.png");
        this.data = [new Properties({...this })];

        this.decorate = async function(callback) {
            this.decorator = new DecorationConcentratorYeast();
            await this.decorator.init(this, callback)
        };

        this.clone = () => {
            let cloned = new ConcentratorYeast()

            cloned.id = this.id;
            cloned.idName = this.idName;
            cloned.type = this.type;
            cloned.x = this.x;
            cloned.y = this.y;
            cloned.height = this.height;
            cloned.width = this.width;
            cloned.expressionVisible = this.expressionVisible
            cloned.data = this.data.map(d => d.clone());
            cloned.decorator = null
            cloned.readOnly = this.readOnly
            cloned.expressionVisible = this.expressionVisible

            return cloned
        }

        this.copyFrom = (node) => {
            this.simpleCopyFrom(node);
            this.data = node.data.map(d => new Properties({...d }));
        }

        this.update = (node) => {
            if (node.attrs) {
                this.data = node.attrs;
            }
        }
    }
}

export { ConcentratorYeast };